<template>
    <div class="animate-pulse">
        <div class="bg-gray-200 rounded-full h-8 w-24"></div>
    </div>
</template>
